// extracted by mini-css-extract-plugin
module.exports = {"rightToUp":"products-table-view-righttoup_rightToUp__3Obai"};